import React, { useState, useEffect, useRef } from "react";
import "./Employee.css";

function Employee() {
  const [task, settask] = useState([]);
  const [dws, setdws] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem("userdetails")) || {
    empname: "Employee",
  };

  const [worksheetData, setWorksheetData] = useState({});
  const fileInputRefs = useRef({});

  const handleChange = (time, value) => {
    const updatedData = { ...worksheetData, [time]: value };
    setWorksheetData(updatedData);
    // localStorage.setItem("dailyWorksheet", JSON.stringify(updatedData));
  };

  const handlecomplete = (id) => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/taskcomplete.php`;
    const formData = new FormData();

    formData.append("id", id);

    fetch(apiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        // settask(data.data);
        gettask();
        alert(data.message);
      })
      .catch((error) => {
        console.error("Error completed task:", error);
        alert("Something went wrong. Please try again.");
      });
  };

  const gettask = () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getemptask.php`;
    const formData = new FormData();

    formData.append("user_id", userDetails.id);

    fetch(apiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        settask(data.data);
        // alert(data.message);
      })
      .catch((error) => {
        console.error("Error assigning task:", error);
        alert("Something went wrong. Please try again.");
      });
  };

  const getdws = () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getdws.php`;
    const formData = new FormData();

    formData.append("user_id", userDetails.id);

    fetch(apiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setdws(data.data);
        // alert(data.message);
      })
      .catch((error) => {
        console.error("Error assigning task:", error);
        alert("Something went wrong. Please try again.");
      });
  };

  useEffect(() => {
    if (userDetails?.role !== "admin") {
      gettask();
      getdws();
    }
  }, []);

  const today = new Date().toISOString().split("T")[0]; // "2025-05-20"

  const timeSlots = [
    "A1 - (9:30 AM - 11:30 PM)",
    "A2 - (11:30 AM- 1:30 PM)",
    "P1 - (2:00 PM - 4:00 PM)",
    "P2 - (4:00 PM- 6:30 PM)",
    "New Learning",
  ];

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("user_id", userDetails?.id);
    formData.append("date", new Date().toISOString().split("T")[0]);
    const mandatorySlots = [
      "A1 - (9:30 AM - 11:30 PM)",
      "A2 - (11:30 AM- 1:30 PM)",
      "P1 - (2:00 PM - 4:00 PM)",
      "P2 - (4:00 PM- 6:30 PM)",
    ];
    // Validate: Ensure all time slots have at least text or file
    for (let slot of mandatorySlots) {
      const data = worksheetData[slot] || {};
      if (!data.text?.trim() && (!data.files || data.files.length === 0)) {
        alert(`Please enter text or upload file for time slot: ${slot}`);
        return;
      }
    }

    // Append data to FormData
    Object.entries(worksheetData).forEach(([slot, data]) => {
      if (data?.text) {
        formData.append(`tasks[${slot}][text]`, data.text);
      }

      if (data?.files?.length > 0) {
        data.files.forEach((file) => {
          formData.append(`tasks[${slot}][files][]`, file);
        });
      }
    });

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/daily.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await res.json();
      console.log(result);

      if (
        res.ok &&
        result.details &&
        result.details.every((item) => item.status === "success")
      ) {
        // Reset worksheet data
        const emptyData = {};
        timeSlots.forEach((slot) => {
          emptyData[slot] = { text: "", files: [] };
        });
        setWorksheetData(emptyData);

        // Clear file inputs manually
        Object.values(fileInputRefs.current).forEach((input) => {
          if (input) input.value = "";
        });
        getdws();

        alert("Tasks submitted successfully.");
      } else {
        alert("Failed to submit tasks. Please check the errors.");
      }
    } catch (error) {
      console.error("Error submitting tasks:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div className="outer-emp">
      {/* task */}
      <div className="emp-container">
        <h1 className="head1">Task Assignment</h1>
        <div className="emptask-container">
          <h2>Today:</h2>{" "}
          {Array.isArray(task) && task.length > 0 ? (
            <>
              {task
                .filter((task) => task.created_at.split(" ")[0] === today)
                .map((item, index) => (
                  <div key={index} className="task-item">
                    <h5 className="assign-name">
                      {item.assign_name}{" "}
                      <h6 className="ps">{item.created_at}</h6>
                    </h5>
                    <h3>{item.task}</h3>
                    <button
                      className="complete-btn"
                      onClick={() => handlecomplete(item.id)}
                      title="Mark as Complete"
                    >
                      ✅tcik
                    </button>
                  </div>
                ))}
              <div className="vline"></div>
              {task.filter((item) => item.created_at.split(" ")[0] !== today)
                .length > 0 ? (
                <>
                  <h2>Earlier:</h2>
                  {task
                    .filter((item) => item.created_at.split(" ")[0] !== today)
                    .map((item, index) => (
                      <div key={index} className="task-item">
                        <h5 className="assign-name">
                          {item.assign_name}
                          <h6 className="ps">{item.created_at}</h6>
                        </h5>
                        <h3>{item.task}</h3>
                        <button
                          className="complete-btn"
                          onClick={() => handlecomplete(item.id)}
                          title="Mark as Complete"
                        >
                          ✅
                        </button>
                      </div>
                    ))}
                </>
              ) : null}
            </>
          ) : (
            <h4>No tasks assigned to you.</h4>
          )}
        </div>
      </div>

      {/* dws */}
      <div className="emdp-container">
        <h1 className="head1">Daily Work Sheet</h1>

        <div className="dws-container">
          <table className="task-table">
            <thead>
              <tr>
                <th>Time Slot</th>
                <th>Enter Task</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(dws) && dws.length > 0 ? (
                <>
                  {Object.entries(
                    dws.reduce((acc, curr) => {
                      if (!acc[curr.time_slot]) acc[curr.time_slot] = [];
                      acc[curr.time_slot].push(curr.task);
                      return acc;
                    }, {})
                  ).map(([slot, tasks], index) => (
                    <tr key={index}>
                      <td
                        style={{
                          width: "30%",
                          verticalAlign: "top",
                          fontWeight: "bold",
                        }}
                      >
                        {slot}
                      </td>
                      <td
                        style={{
                          maxWidth: "300px",
                          // width: "30%",
                          // verticalAlign: "top",
                          // fontWeight: "bold",
                        }}
                      >
                        {tasks.map((task, idx) => {
                          const isFile =
                            /\.(pdf|docx?|xlsx?|png|jpe?g|txt)$/i.test(task);
                          return (
                            <div key={idx} style={{ marginBottom: "6px" }}>
                              {isFile ? (
                                <a
                                  href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${task}`}
                                  target="_blank"
                                  download // <-- this triggers the download
                                  style={{
                                    color: "#007bff",
                                    textDecoration: "underline",
                                  }}
                                >
                                  {task}
                                </a>
                              ) : (
                                <span>{task}</span>
                              )}
                            </div>
                          );
                        })}
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <>
                  {timeSlots.map((slot, index) => (
                    <tr key={index}>
                      <td style={{ margin: "0px", width: "25%" }}>{slot}</td>
                      <td>
                        <textarea
                          required
                          placeholder="Enter task"
                          value={worksheetData[slot]?.text || ""}
                          onChange={(e) =>
                            handleChange(slot, {
                              ...worksheetData[slot],
                              text: e.target.value,
                            })
                          }
                          className="task-textarea"
                        />
                        <input
                          type="file"
                          multiple
                          ref={(el) => (fileInputRefs.current[slot] = el)}
                          onChange={(e) =>
                            handleChange(slot, {
                              ...worksheetData[slot],
                              files: Array.from(e.target.files),
                            })
                          }
                          className="file-input"
                        />
                        {worksheetData[slot]?.files?.length > 0 && (
                          <ul className="file-list">
                            {worksheetData[slot].files.map((file, i) => (
                              <li key={i}>{file.name}</li>
                            ))}
                          </ul>
                        )}
                      </td>

                      {/* <td>file</td> */}
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>

          {Array.isArray(dws) && dws.length > 0 ? (
            <h4
              style={{
                color: "#b31010",
                display: "flex",
                justifyContent: "center",
              }}
            >
              Submitted Time: {dws[0].submit_time}
            </h4>
          ) : (
            <>
              <div className="sbtd">
                <button
                  className="shbnd"
                  onClick={handleSubmit}
                  // onClick={handledws}
                >
                  Submit
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Employee;
